import { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import DropdownFilter from "./DropdownFilter";
import InputData from "./InputData";
import InputTextArea from "./InputTextArea";
import CheckBox from "./CheckBox";
import ButtonIconV from "./ButtonIconV";
import LoadingScreen from "./LoadingScreen";
import "../css/BasicOptometry.css";
import { post } from "../js/post";
import {
  sensoryStructure,
  hessLancasterStructure,
  userData,
  selectedOptic,
  inputOnEnter,
  areObjectsEqual,
  HESSLANCASTERLIST,
  STEREOPSISLIST,
  deviationFactor,
  focusElement,
  validateSensoryData,
} from "../js/utils";
import moment from "moment";
import TooltipBox from "./Tooltip";
import { useOptometrists } from "../hooks/useOptometrists";
import { AdvancedOptometryReportPopup } from "./AdvancedOptometryReportPopup";

export default function AdvancedOptometrySensory(props) {
  const [currentSensory, setCurrentSensory] = useState(sensoryStructure);
  const [currentSensoryEdit, setCurrentSensoryEdit] =
    useState(sensoryStructure);
  const optometristList = [{ id: "", text: "" }, ...useOptometrists()];
  const [dateHistoryList, setDateHistoryList] = useState([]);
  const [selectedDate, setSelectedDate] = useState({ id: "", text: "" });
  const [sensoryId, setSensoryId] = useState(props.sensoryId);
  const [currentHessLancasterEdit, setCurrentHessLancasterEdit] = useState(
    hessLancasterStructure,
  );
  const [loadingData, setLoadingData] = useState(true);
  const [reportPopup, setReportPopup] = useState(false);

  const getSensoryHistory = async () => {
    const response = await post("ListarFechasHistoricoSensorial.php", {
      token: userData.token,
      idPaciente: props.patientId,
      optica: selectedOptic.id,
    });
    if (response.length > 0) {
      const found = response.find((e) => {
        return e.idSensorial === sensoryId;
      });
      if (found) {
        setSelectedDate({
          id: found.idSensorial,
          text: found.fecha,
        });
        setSensoryId(found.idSensorial);
      }
    }
    setDateHistoryList(response);
  };

  const getSensory = async (sensoryId) => {
    const response = await post("ObtenerSensorial.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idSensorial: sensoryId,
    });

    setCurrentSensoryEdit({
      ...response,
      idPaciente: props.patientId,
      idSensorial: sensoryId,
    });
    setCurrentSensory({
      ...response,
      idPaciente: props.patientId,
      idSensorial: sensoryId,
    });
  };

  const getHessLancaster = async (sensoryId) => {
    const response = await post("ObtenerHessLancaster.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idSensorial: sensoryId,
    });
    setCurrentHessLancasterEdit({
      ...response,
      punto1_od_x: parseInt(response.punto1_od_x) + deviationFactor,
      punto1_od_y: parseInt(response.punto1_od_y) + deviationFactor,
      punto2_od_x: parseInt(response.punto2_od_x) + deviationFactor,
      punto2_od_y: parseInt(response.punto2_od_y) + deviationFactor,
      punto3_od_x: parseInt(response.punto3_od_x) + deviationFactor,
      punto3_od_y: parseInt(response.punto3_od_y) + deviationFactor,
      punto4_od_x: parseInt(response.punto4_od_x) + deviationFactor,
      punto4_od_y: parseInt(response.punto4_od_y) + deviationFactor,
      punto5_od_x: parseInt(response.punto5_od_x) + deviationFactor,
      punto5_od_y: parseInt(response.punto5_od_y) + deviationFactor,
      punto6_od_x: parseInt(response.punto6_od_x) + deviationFactor,
      punto6_od_y: parseInt(response.punto6_od_y) + deviationFactor,
      punto7_od_x: parseInt(response.punto7_od_x) + deviationFactor,
      punto7_od_y: parseInt(response.punto7_od_y) + deviationFactor,
      punto8_od_x: parseInt(response.punto8_od_x) + deviationFactor,
      punto8_od_y: parseInt(response.punto8_od_y) + deviationFactor,
      punto9_od_x: parseInt(response.punto9_od_x) + deviationFactor,
      punto9_od_y: parseInt(response.punto9_od_y) + deviationFactor,
      punto1_oi_x: parseInt(response.punto1_oi_x) + deviationFactor,
      punto1_oi_y: parseInt(response.punto1_oi_y) + deviationFactor,
      punto2_oi_x: parseInt(response.punto2_oi_x) + deviationFactor,
      punto2_oi_y: parseInt(response.punto2_oi_y) + deviationFactor,
      punto3_oi_x: parseInt(response.punto3_oi_x) + deviationFactor,
      punto3_oi_y: parseInt(response.punto3_oi_y) + deviationFactor,
      punto4_oi_x: parseInt(response.punto4_oi_x) + deviationFactor,
      punto4_oi_y: parseInt(response.punto4_oi_y) + deviationFactor,
      punto5_oi_x: parseInt(response.punto5_oi_x) + deviationFactor,
      punto5_oi_y: parseInt(response.punto5_oi_y) + deviationFactor,
      punto6_oi_x: parseInt(response.punto6_oi_x) + deviationFactor,
      punto6_oi_y: parseInt(response.punto6_oi_y) + deviationFactor,
      punto7_oi_x: parseInt(response.punto7_oi_x) + deviationFactor,
      punto7_oi_y: parseInt(response.punto7_oi_y) + deviationFactor,
      punto8_oi_x: parseInt(response.punto8_oi_x) + deviationFactor,
      punto8_oi_y: parseInt(response.punto8_oi_y) + deviationFactor,
      punto9_oi_x: parseInt(response.punto9_oi_x) + deviationFactor,
      punto9_oi_y: parseInt(response.punto9_oi_y) + deviationFactor,
    });
  };

  const resetSensoryState = () => {
    setCurrentSensory({
      ...sensoryStructure,
      fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setCurrentSensoryEdit({
      ...sensoryStructure,
      fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setSensoryId(-1);
    props.saveLastSensoryIdVisited(-1);
    setSelectedDate({
      id: -1,
      text: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
  };

  const saveSensory = async () => {
    const response = await post("GuardarSensorial.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idSensorial: sensoryId,
      idPaciente: props.patientId,
      ...currentSensoryEdit,
    });
    setSelectedDate({
      id: response.idSensorial,
      text: currentSensoryEdit.fecha,
    });
    await props.saveHessLancaster(response.idSensorial);
    setSensoryId(response.idSensorial);
    setCurrentSensory(currentSensoryEdit);
    props.saveLastSensoryIdVisited(response.idSensorial);
    props.createPopupQuestion(
      `Los cambios se han guardado con éxito.`,
      props.removePopupQuestion,
      null,
      "Entendido",
    );
  };

  const deleteSensory = async () => {
    await post("EliminarSensorial.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idSensorial: sensoryId,
      idUsuario: userData.id,
    });
  };

  const selectSensoryAfterDeleting = async () => {
    const response = await post("ListarFechasHistoricoSensorial.php", {
      token: userData.token,
      idPaciente: props.patientId,
      optica: selectedOptic.id,
    });
    if (response.length > 0) {
      setSelectedDate({
        id: response[0].idSensorial,
        text: response[0].fecha,
      });
      setSensoryId(response[0].idSensorial);
      setDateHistoryList(response);
      await getSensory(response[0].idSensorial);
      await getHessLancaster(response[0].idSensorial);
      props.saveLastSensoryIdVisited(response[0].idSensorial);
    } else {
      setSelectedDate({
        id: -1,
        text: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
      setSensoryId(-1);
      props.saveLastSensoryIdVisited(-1);
      setCurrentSensory(sensoryStructure);
      setCurrentSensoryEdit(sensoryStructure);
    }
  };

  const cancelChanges = async () => {
    if (dateHistoryList.length > 0) {
      // 1. Si estamos creando una ficha, cargamos la última.
      if (sensoryId === -1) {
        setSelectedDate({
          id: dateHistoryList[0].idSensorial,
          text: dateHistoryList[0].fecha,
        });
        setSensoryId(dateHistoryList[0].idSensorial);
        props.saveLastSensoryIdVisited(dateHistoryList[0].idSensorial);
        await getSensory(dateHistoryList[0].idSensorial);
        await getHessLancaster(dateHistoryList[0].idSensorial);
      } else {
        // 2. Si estamos viendo una ficha, cancelamos los cambios.
        setCurrentSensoryEdit(currentSensory);
      }
    } else {
      setCurrentSensoryEdit(currentSensory);
    }
  };

  function focusRequiredField() {
    const fields = [{ value: currentSensoryEdit.optometrista, elementId: 53 }];

    const emptyField = fields.find((field) => field.value === "");
    if (emptyField) {
      focusElement(emptyField.elementId);
    }
  }

  const printFile = async (data) => {
    if (sensoryId === -1) return;
    const response = await post(
      "/support-extra/gestionDocumental/GenerarFichaOptometriaAvanzada.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idPaciente: props.patientId,
        anamnesis: data.anamnesis,
        anamnesisNotas: data.anamnesisNotes,
        refractivo: data.refractive,
        refractivoNotas: data.refractiveNotes,
        oculomotor: data.oculomotor,
        oculomotorNotas: data.oculomotorNotes,
        binocular: data.binocular,
        binocularNotas: data.binocularNotes,
        acomodativo: data.accommodative,
        acomodativoNotas: data.accommodativeNotes,
        sensorial: data.sensory,
        sensorialNotas: data.sensoryNotes,
        saludOcular: data.eyeHealth,
        saludOcularNotas: data.eyeHealthNotes,
        email: data.email,
      },
    );
    // console.log(
      // "GENERANDO: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // idPaciente: props.patientId,
        // anamnesis: data.anamnesis,
        // anamnesisNotas: data.anamnesisNotes,
        // refractivo: data.refractive,
        // refractivoNotas: data.refractiveNotes,
        // oculomotor: data.oculomotor,
        // oculomotorNotas: data.oculomotorNotes,
        // binocular: data.binocular,
        // binocularNotas: data.binocularNotes,
        // acomodativo: data.accommodative,
        // acomodativoNotas: data.accommodativeNotes,
        // sensorial: data.sensory,
        // sensorialNotas: data.sensoryNotes,
        // saludOcular: data.eyeHealth,
        // saludOcularNotas: data.eyeHealthNotes,
        // email: data.email,
      // },
      // response,
    // );
    if (response.error !== "") {
      props.createPopupQuestion(
        response.error,
        () => {
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `ficha_optometria_avanzada_sensorial.pdf`;
      a.click();
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await getSensoryHistory();
      if (sensoryId !== -1) {
        await getSensory(sensoryId);
        await getHessLancaster(sensoryId);
      } else {
        setSelectedDate({
          id: -1,
          text: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        setCurrentSensoryEdit({
          ...currentSensoryEdit,
          fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        setCurrentSensory({
          ...currentSensory,
          fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
      }
      focusElement(54);
      setLoadingData(false);
    };
    loadData();
  }, [sensoryId]);

  useEffect(() => {
    props.pendingChanges({
      changes: !areObjectsEqual(currentSensory, currentSensoryEdit),
      dataToSave: currentSensoryEdit,
    });
  }, [currentSensoryEdit, props.pendingChanges]);

  useEffect(() => {
    if (props.testHL !== null) {
      setCurrentSensoryEdit({
        ...currentSensoryEdit,
        hess_lancaster: props.testHL,
      });
    }
  }, [props.testHL]);

  useEffect(() => {
    if (props.diagnosisValue !== currentSensoryEdit.diagnostico) {
      setCurrentSensoryEdit({
        ...currentSensoryEdit,
        diagnostico: props.diagnosisValue,
      });
    }
  }, [props.diagnosisValue]);

  return (
    <>
      {loadingData && (
        <LoadingScreen message="Cargando ficha de sensorial..."></LoadingScreen>
      )}
      {!loadingData && (
        <div className="tab-content-screen bg-transparent">
          <div className="content-grid">
            {reportPopup && (
              <AdvancedOptometryReportPopup
                type="sensory"
                createPopupQuestion={props.createPopupQuestion}
                removePopupQuestion={props.removePopupQuestion}
                onExport={async (data) => {
                  await printFile(data);
                }}
                onClose={() => {
                  setReportPopup(false);
                }}
              />
            )}
            <div
              className="popup-screen-box external-container"
              style={{ gridColumn: "1/span 3", gridRow: "1/span 1" }}
            >
              <div className="popup-screen-box-info">
                <div className="cell-extra">
                  <span className="label">Creación</span>
                </div>
                <div className="cell-extra w-220">
                  <div className="input-data input-full">
                    <input
                      type="datetime-local"
                      max="9999-12-31T23:59"
                      step="1"
                      tabIndex={51}
                      className="input-field"
                      value={currentSensoryEdit.fecha}
                      onChange={(e) => {
                        setCurrentSensoryEdit({
                          ...currentSensoryEdit,
                          fecha: e.target.value,
                        });
                      }}
                      onKeyUp={(e) => {
                        inputOnEnter(e);
                      }}
                    ></input>
                  </div>
                </div>
                <div className="cell-extra">
                  <span className="label">
                    Histórico ({dateHistoryList.length})
                  </span>
                </div>
                <div className="cell-extra">
                  <DropdownFilter
                    tabIndex={52}
                    selectedOptions={[]}
                    optionList={dateHistoryList.map((item) => ({
                      id: item.idSensorial,
                      text: moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
                        "DD/MM/YYYY HH:mm:ss",
                      ),
                      active: selectedDate.id === item.idSensorial,
                    }))}
                    size={2}
                    op={moment(selectedDate.text, "YYYY-MM-DD HH:mm:ss").format(
                      "DD/MM/YYYY HH:mm:ss",
                    )}
                    disabled={sensoryId === -1}
                    onChange={async (e) => {
                      setLoadingData(true);
                      setCurrentSensoryEdit(sensoryStructure);
                      setSelectedDate({
                        id: e.id,
                        text: moment(e.text, "DD/MM/YYYY HH:mm:ss").format(
                          "YYYY-MM-DD HH:mm:ss",
                        ),
                      });
                      setSensoryId(e.id);
                      props.saveLastSensoryIdVisited(e.id);
                    }}
                  ></DropdownFilter>
                </div>
                <div className="cell-extra cell-extra-optometrista">
                  <span className="label">Optometrista (*)</span>
                </div>
                <div className="cell-extra combined-cells-3">
                  <Dropdown
                    tabIndex={53}
                    optionList={optometristList}
                    size={0}
                    op={currentSensoryEdit.optometrista}
                    onChange={(e) => {
                      setCurrentSensoryEdit({
                        ...currentSensoryEdit,
                        optometrista: e.text,
                      });
                    }}
                  ></Dropdown>
                </div>
              </div>
            </div>
            <div
              className="popup-screen-box external-container"
              style={{ gridColumn: "4/span 3", gridRow: "1/span 1" }}
            >
              <ButtonIconV
                text="Nuevo"
                icon={
                  sensoryId !== -1
                    ? "/images/create-blue.svg"
                    : "/images/create-gray.svg"
                }
                onClick={() => {
                  if (sensoryId !== -1) {
                    if (!areObjectsEqual(currentSensory, currentSensoryEdit)) {
                      props.createPopupQuestion(
                        `Existen cambios sin guardar en la ficha actual. ¿Desea guardar los cambios antes de crear una nueva ficha?`,
                        async () => {
                          await saveSensory();
                          props.removePopupQuestion();
                          resetSensoryState();
                        },
                        async () => {
                          props.removePopupQuestion();
                          resetSensoryState();
                        },
                        "Sí",
                        "No",
                      );
                    } else {
                      resetSensoryState();
                    }
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Guardar"
                icon="/images/save-blue.svg"
                onClick={async () => {
                  if (
                    currentSensoryEdit.optometrista !== "" &&
                    validateSensoryData(currentSensoryEdit)
                  ) {
                    await saveSensory();
                    await getSensoryHistory();
                    props.updateTab();
                  } else {
                    props.createPopupQuestion(
                      `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
                      () => {
                        focusRequiredField();
                        props.removePopupQuestion();
                      },
                      null,
                      "Entendido",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Cancelar"
                icon="/images/cancel-blue.svg"
                onClick={() => {
                  if (
                    dateHistoryList.length === 0 &&
                    areObjectsEqual(currentSensory, currentSensoryEdit)
                  ) {
                    props.removePopupQuestion();
                  } else if (
                    !areObjectsEqual(currentSensory, currentSensoryEdit) ||
                    sensoryId === -1
                  ) {
                    props.createPopupQuestion(
                      `¿Desea cancelar los cambios realizados?`,
                      async () => {
                        await cancelChanges();
                        props.removePopupQuestion();
                      },
                      props.removePopupQuestion,
                      "Sí",
                      "No",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Recargar"
                icon={
                  sensoryId !== -1
                    ? "/images/update-blue.svg"
                    : "/images/update-gray.svg"
                }
                onClick={() => {
                  if (sensoryId !== -1) {
                    props.createPopupQuestion(
                      `¿Desea recargar esta ficha de sensorial?`,
                      async () => {
                        await getSensory(sensoryId);
                        await getHessLancaster(sensoryId);
                        props.removePopupQuestion();
                      },
                      props.removePopupQuestion,
                      "Sí",
                      "No",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Eliminar"
                icon={
                  sensoryId !== -1
                    ? "/images/remove-blue.svg"
                    : "/images/remove-gray.svg"
                }
                onClick={() => {
                  if (sensoryId !== -1) {
                    props.createPopupQuestion(
                      `¿Desea eliminar esta ficha de sensorial?`,
                      async () => {
                        await deleteSensory();
                        await getSensoryHistory();
                        await selectSensoryAfterDeleting();
                        props.updateTab();
                        props.removePopupQuestion();
                      },
                      props.removePopupQuestion,
                      "Sí",
                      "No",
                    );
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Notas"
                icon={
                  sensoryId !== -1
                    ? "/images/write-blue.svg"
                    : "/images/write-gray.svg"
                }
                onClick={() => {
                  if (sensoryId !== -1) {
                    props.openDiagnosisPopup(currentSensoryEdit.diagnostico);
                  }
                }}
              ></ButtonIconV>
              <ButtonIconV
                text="Imprimir"
                icon={
                  sensoryId !== -1
                    ? "/images/print-blue.svg"
                    : "/images/print-gray.svg"
                }
                onClick={() => {
                  if (sensoryId !== -1) {
                    setReportPopup(true);
                  }
                }}
              ></ButtonIconV>
            </div>
            <div
              className="popup-screen-box external-container"
              style={{ gridColumn: "1/span 6", gridRow: "2/span 1" }}
            >
              <div className="popup-screen-content-col w-100">
                <div className="opt-table-container opt-table-container-npb">
                  <div className="opt-table-title">
                    Fusión
                    <div>
                      <img
                        src="/images/info-blue.svg"
                        loading="lazy"
                        alt="Icon"
                        className="cell-icon"
                        data-tooltip-id="tt1"
                      ></img>
                      <TooltipBox
                        id="tt1"
                        content={
                          <div className="opt-table-tooltip grid-5">
                            <div className="cell combined-cells-5 cell-start-content">
                              Valores normalizados para la fusión:
                            </div>
                            <div className="cell cell-start-content combined-cells-5"></div>
                            <div className="cell cell-start-content combined-cells-5">
                              Fusión en todas las distancias.
                            </div>
                            <div className="cell cell-start-content combined-cells-5">
                              CSN sin supresión.
                            </div>
                          </div>
                        }
                      ></TooltipBox>
                    </div>
                  </div>
                </div>
                <div className="double-col">
                  <div className="w-50">
                    <div className="opt-table-container opt-table-container-npt">
                      <div
                        className="opt-table-content grid-9"
                        id="sensory-fusion"
                      >
                        <div className="cell opt-table-subtitle combined-cells-9 cell-start-content">
                          Test de Worth
                        </div>
                        <div className="cell cell-label combined-cells-9">
                          Lejos
                        </div>
                        <div className="worth-test-container cell combined-cells-9">
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_lejos:
                                  currentSensoryEdit.test_worth_lejos === 0
                                    ? -1
                                    : 0,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_lejos === 0
                                  ? "/images/worth/test-worth-01-on.png"
                                  : "/images/worth/test-worth-01-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={54}
                              active={currentSensoryEdit.test_worth_lejos === 0}
                              onClick={() => {}}
                              ttId="tt2"
                            ></CheckBox>
                            <TooltipBox
                              id="tt2"
                              content={<div className="cell">Fusión</div>}
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_lejos:
                                  currentSensoryEdit.test_worth_lejos === 1
                                    ? -1
                                    : 1,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_lejos === 1
                                  ? "/images/worth/test-worth-02-on.png"
                                  : "/images/worth/test-worth-02-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={55}
                              active={currentSensoryEdit.test_worth_lejos === 1}
                              onClick={() => {}}
                              ttId="tt3"
                            ></CheckBox>
                            <TooltipBox
                              id="tt3"
                              content={<div className="cell">Supresión OI</div>}
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_lejos:
                                  currentSensoryEdit.test_worth_lejos === 2
                                    ? -1
                                    : 2,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_lejos === 2
                                  ? "/images/worth/test-worth-03-on.png"
                                  : "/images/worth/test-worth-03-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={56}
                              active={currentSensoryEdit.test_worth_lejos === 2}
                              onClick={() => {}}
                              ttId="tt4"
                            ></CheckBox>
                            <TooltipBox
                              id="tt4"
                              content={<div className="cell">Supresión OD</div>}
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_lejos:
                                  currentSensoryEdit.test_worth_lejos === 3
                                    ? -1
                                    : 3,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_lejos === 3
                                  ? "/images/worth/test-worth-04-on.png"
                                  : "/images/worth/test-worth-04-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={57}
                              active={currentSensoryEdit.test_worth_lejos === 3}
                              onClick={() => {}}
                              ttId="tt5"
                            ></CheckBox>
                            <TooltipBox
                              id="tt5"
                              content={
                                <div className="cell">ENDO desviación</div>
                              }
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_lejos:
                                  currentSensoryEdit.test_worth_lejos === 4
                                    ? -1
                                    : 4,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_lejos === 4
                                  ? "/images/worth/test-worth-05-on.png"
                                  : "/images/worth/test-worth-05-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={58}
                              active={currentSensoryEdit.test_worth_lejos === 4}
                              onClick={() => {}}
                              ttId="tt6"
                            ></CheckBox>
                            <TooltipBox
                              id="tt6"
                              content={
                                <div className="cell">EXO desviación</div>
                              }
                            ></TooltipBox>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="opt-table-container opt-table-container-npt">
                      <div
                        className="opt-table-content grid-9"
                        id="sensory-fusion"
                      >
                        <div className="cell opt-table-subtitle combined-cells-9 cell-start-content">
                          Observaciones
                        </div>
                        <div className="cell combined-cells-9">
                          <InputTextArea
                            tabIndex={64}
                            maxLength={400}
                            id="observaciones"
                            type="type-full"
                            size={0}
                            input={
                              currentSensoryEdit.observaciones_test_worth_lejos
                            }
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                observaciones_test_worth_lejos: e,
                              });
                            }}
                          ></InputTextArea>
                        </div>
                        <div className="cell combined-cells-9"></div>
                        <div className="cell opt-table-subtitle combined-cells-4 cell-start-content">
                          Filtro rojo
                        </div>
                        <div className="cell"></div>
                        <div className="cell opt-table-subtitle combined-cells-4 cell-start-content">
                          Bagolini
                        </div>
                        <div className="cell cell-label combined-cells-4 cell-start-content">
                          Lejos
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label combined-cells-4 cell-start-content">
                          Lejos
                        </div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={66}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.filtro_rojo_lejos}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                filtro_rojo_lejos: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                        <div className="cell"></div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={68}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.bagolini_lejos}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                bagolini_lejos: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                        <div className="cell cell-label combined-cells-4 cell-start-content">
                          Cerca
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label combined-cells-4 cell-start-content">
                          Cerca
                        </div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={67}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.filtro_rojo_cerca}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                filtro_rojo_cerca: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                        <div className="cell"></div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={69}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.bagolini_cerca}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                bagolini_cerca: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                      </div>
                    </div>
                    <div className="opt-table-container opt-table-container-npt">
                      <div className="opt-table-title">
                        Percepción del color
                      </div>
                      <div className="opt-table-content grid-9">
                        <div className="cell opt-table-subtitle combined-cells-4 cell-start-content">
                          Test de Ishihara
                        </div>
                        <div className="cell"></div>
                        <div className="cell opt-table-subtitle combined-cells-4 cell-start-content">
                          Test de Farnsworth
                        </div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={70}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.test_ishihara}
                            bkg={true}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_ishihara: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                        <div className="cell"></div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={71}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.test_farnsworth}
                            bkg={true}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_farnsworth: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-50">
                    <div className="opt-table-container opt-table-container-npt">
                      <div
                        className="opt-table-content grid-9"
                        id="sensory-fusion"
                      >
                        <div className="cell opt-table-subtitle combined-cells-9 cell-start-content"></div>
                        <div className="cell cell-label combined-cells-9">
                          Cerca
                        </div>
                        <div className="worth-test-container cell combined-cells-9">
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_cerca:
                                  currentSensoryEdit.test_worth_cerca === 0
                                    ? -1
                                    : 0,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_cerca === 0
                                  ? "/images/worth/test-worth-01-on.png"
                                  : "/images/worth/test-worth-01-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={59}
                              active={currentSensoryEdit.test_worth_cerca === 0}
                              onClick={() => {}}
                              ttId="tt7"
                            ></CheckBox>
                            <TooltipBox
                              id="tt7"
                              content={<div className="cell">Fusión</div>}
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_cerca:
                                  currentSensoryEdit.test_worth_cerca === 1
                                    ? -1
                                    : 1,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_cerca === 1
                                  ? "/images/worth/test-worth-02-on.png"
                                  : "/images/worth/test-worth-02-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={60}
                              active={currentSensoryEdit.test_worth_cerca === 1}
                              onClick={() => {}}
                              ttId="tt8"
                            ></CheckBox>
                            <TooltipBox
                              id="tt8"
                              content={<div className="cell">Supresión OI</div>}
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_cerca:
                                  currentSensoryEdit.test_worth_cerca === 2
                                    ? -1
                                    : 2,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_cerca === 2
                                  ? "/images/worth/test-worth-03-on.png"
                                  : "/images/worth/test-worth-03-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={61}
                              active={currentSensoryEdit.test_worth_cerca === 2}
                              onClick={() => {}}
                              ttId="tt9"
                            ></CheckBox>
                            <TooltipBox
                              id="tt9"
                              content={<div className="cell">Supresión OD</div>}
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_cerca:
                                  currentSensoryEdit.test_worth_cerca === 3
                                    ? -1
                                    : 3,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_cerca === 3
                                  ? "/images/worth/test-worth-04-on.png"
                                  : "/images/worth/test-worth-04-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={62}
                              active={currentSensoryEdit.test_worth_cerca === 3}
                              onClick={() => {}}
                              ttId="tt10"
                            ></CheckBox>
                            <TooltipBox
                              id="tt10"
                              content={
                                <div className="cell">ENDO desviación</div>
                              }
                            ></TooltipBox>
                          </div>
                          <div
                            className="worth-test-op"
                            onClick={() => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                test_worth_cerca:
                                  currentSensoryEdit.test_worth_cerca === 4
                                    ? -1
                                    : 4,
                              });
                            }}
                          >
                            <img
                              src={
                                currentSensoryEdit.test_worth_cerca === 4
                                  ? "/images/worth/test-worth-05-on.png"
                                  : "/images/worth/test-worth-05-off.png"
                              }
                              loading="lazy"
                              alt="Icon"
                              className="worth-img"
                            ></img>
                            <CheckBox
                              tabIndex={63}
                              active={currentSensoryEdit.test_worth_cerca === 4}
                              onClick={() => {}}
                              ttId="tt11"
                            ></CheckBox>
                            <TooltipBox
                              id="tt11"
                              content={
                                <div className="cell">EXO desviación</div>
                              }
                            ></TooltipBox>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="opt-table-container opt-table-container-npt">
                      <div
                        className="opt-table-content grid-9"
                        id="sensory-fusion"
                      >
                        <div className="cell opt-table-subtitle combined-cells-9 cell-start-content">
                          Observaciones
                        </div>
                        <div className="cell combined-cells-9">
                          <InputTextArea
                            tabIndex={65}
                            maxLength={400}
                            id="observaciones"
                            type="type-full"
                            size={0}
                            input={
                              currentSensoryEdit.observaciones_test_worth_cerca
                            }
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                observaciones_test_worth_cerca: e,
                              });
                            }}
                          ></InputTextArea>
                        </div>
                        <div className="cell combined-cells-9"></div>
                        <div className="cell opt-table-subtitle combined-cells-2 cell-start-content">
                          Hess - Lancaster
                        </div>
                        <div className="cell">
                          <button
                            onClick={() => {
                              props.toggleHessLancaster(
                                currentHessLancasterEdit,
                                currentSensoryEdit.hess_lancaster,
                              );
                            }}
                          >
                            <img
                              src="/images/axis-blue.svg"
                              loading="lazy"
                              alt="Icon"
                              className="cell-icon"
                            ></img>
                          </button>
                        </div>
                        <div className="cell">
                          <img
                            src="/images/info-blue.svg"
                            loading="lazy"
                            alt="Icon"
                            className="cell-icon"
                            data-tooltip-id="tt12"
                          ></img>
                          <TooltipBox
                            id="tt12"
                            content={
                              <div className="opt-table-tooltip grid-5">
                                <div className="cell combined-cells-5 cell-start-content">
                                  Valores normalizados para la fusión:
                                </div>
                                <div className="cell cell-start-content combined-cells-5"></div>
                                <div className="cell cell-start-content combined-cells-5">
                                  Versiones normales sin HIPER o hIPO acciones
                                  musculares.
                                </div>
                              </div>
                            }
                          ></TooltipBox>
                        </div>
                        <div className="cell"></div>
                        <div className="cell opt-table-subtitle combined-cells-3 cell-start-content">
                          Estereopsis
                        </div>
                        <div className="cell">
                          <img
                            src="/images/info-blue.svg"
                            loading="lazy"
                            alt="Icon"
                            className="cell-icon"
                            data-tooltip-id="tt13"
                          ></img>
                          <TooltipBox
                            id="tt13"
                            content={
                              <div className="opt-table-tooltip grid-5">
                                <div className="cell combined-cells-5 cell-start-content">
                                  Valores normales para la estereopsis:
                                </div>
                                <div className="cell cell-start-content combined-cells-5"></div>
                                <div className="cell cell-start-content combined-cells-5">
                                  Valores orientativos: 20 ± 10 " de arco.
                                </div>
                              </div>
                            }
                          ></TooltipBox>
                        </div>
                        <div className="cell combined-cells-9"></div>
                        <div className="cell cell-label">Test</div>
                        <div className="cell cell-label combined-cells-3 cell-start-content">
                          <Dropdown
                            tabIndex={72}
                            optionList={HESSLANCASTERLIST}
                            size={0}
                            op={currentSensoryEdit.hess_lancaster}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                hess_lancaster: e.text,
                              });
                            }}
                          ></Dropdown>
                        </div>
                        <div className="cell cell-label">Test</div>
                        <div className="cell cell-label combined-cells-2 cell-start-content">
                          <Dropdown
                            tabIndex={73}
                            optionList={STEREOPSISLIST}
                            size={0}
                            op={currentSensoryEdit.estereopsis}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                estereopsis: e.text,
                              });
                            }}
                          ></Dropdown>
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={74}
                            type="type-positive-float"
                            size={0}
                            input={currentSensoryEdit.valor_estereopsis}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                valor_estereopsis: e,
                              });
                            }}
                          ></InputData>
                        </div>
                        <div className="cell cell-label cell-start-content">
                          "
                        </div>
                        <div className="cell combined-cells-9"></div>
                        <div className="cell opt-table-subtitle combined-cells-9 cell-start-content">
                          Prisma de 4 Δ
                        </div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={76}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.prisma_4a}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                prisma_4a: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                        <div className="cell"></div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={75}
                            maxLength={400}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.observaciones_estereopsis}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                observaciones_estereopsis: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                        <div
                          className="cell combined-cells-9"
                          style={{ height: "55px" }}
                        ></div>
                        <div className="cell opt-table-subtitle combined-cells-4 cell-start-content">
                          Rejilla de Amsler
                        </div>
                        <div className="cell"></div>
                        <div className="cell opt-table-subtitle combined-cells-4 cell-start-content">
                          Sensibilidad al contraste
                        </div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={77}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.rejilla_amsler}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                rejilla_amsler: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                        <div className="cell"></div>
                        <div className="cell combined-cells-4 cell-start-content">
                          <InputTextArea
                            tabIndex={78}
                            maxLength={200}
                            type="type-full"
                            size={0}
                            input={currentSensoryEdit.sensibilidad_contraste}
                            onChange={(e) => {
                              setCurrentSensoryEdit({
                                ...currentSensoryEdit,
                                sensibilidad_contraste: e,
                              });
                            }}
                            extra="small-height"
                          ></InputTextArea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
